module.exports = __webpack_public_path__ + "0bdd428237c61a6749773fa7e6a6654a.png";